import * as mock from "../mocks/accountServiceAccounts.mock.js";

export function listAccountServiceAccounts(accountId) {
  return mock.listAccountServiceAccounts(accountId);
}

export function createAccountServiceAccount(accountId, payload) {
  return mock.createAccountServiceAccount(accountId, payload);
}

export function updateAccountServiceAccount(accountId, serviceAccountId, payload) {
  return mock.updateAccountServiceAccount(accountId, serviceAccountId, payload);
}

export function rotateAccountServiceAccountKeys(accountId, serviceAccountId) {
  return mock.rotateAccountServiceAccountKeys(accountId, serviceAccountId);
}

export function deleteAccountServiceAccount(accountId, serviceAccountId) {
  return mock.deleteAccountServiceAccount(accountId, serviceAccountId);
}
